import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import App from './App';
import { UserProvider } from '#GameFrontend/contexts/UserContext';
import { DevGateProvider } from '#GameFrontend/contexts/DevGateContext';
import DevAuthGate from '#GameFrontend/components/DevAuthGate';
import './i18n.ts';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<DevGateProvider>
		<DevAuthGate>
			<UserProvider>
				<App />
			</UserProvider>
		</DevAuthGate>
	</DevGateProvider>
);
